import { render, staticRenderFns } from "./card-module.vue?vue&type=template&id=655874fb&"
import script from "./card-module.vue?vue&type=script&lang=js&"
export * from "./card-module.vue?vue&type=script&lang=js&"
import style0 from "./card-module.vue?vue&type=style&index=0&id=655874fb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports